import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Link, Stack, TextField, Typography } from "@mui/material";

type Props = {
  adminKey: string;
  onAdminKeyChange: (value: string) => void;
};

export default function AdminKeyStep({ adminKey, onAdminKeyChange }: Props) {
  return (
    <Stack data-cy="admin-key-step" spacing={4}>
      <Typography variant="h3">Create an admin key and provide below</Typography>

      <Stack spacing={2}>
        <Box display="flex">
          <Typography variant="body1">1. Open the</Typography>
          &nbsp;
          <Link
            sx={{
              alignItems: "center",
              display: "flex",
              gap: 0.5,
            }}
            color="primary"
            variant="body1"
            underline="none"
            target="_blank"
            href="https://platform.openai.com/settings/organization/admin-keys"
          >
            OpenAI dashboard
            <OpenInNewIcon fontSize="inherit" />
          </Link>
        </Box>
        <Typography variant="body1">2. Navigate to Admin Keys in the Settings page</Typography>
        <Typography variant="body1">3. Change the Permissions to RESTRICTED</Typography>
        <Typography variant="body1">4. Change Management API Scope to READ (optional)</Typography>
        <Typography variant="body1">5. Change Usage API Scope to READ</Typography>
        <Typography variant="body1">6. Select CREATE ADMIN KEY</Typography>
        <Typography variant="body1">7. Paste the created admin key below</Typography>
      </Stack>

      <TextField
        label="Admin Key"
        fullWidth
        type="password"
        value={adminKey}
        required
        onChange={(event) => {
          onAdminKeyChange(event.target.value);
        }}
        placeholder="sk-xxxxxxxxxxxxxxxxxxxxxxxx"
      />
    </Stack>
  );
}
